import React from "react";
import style from "./style.module.css";
import gif from "../../Assets/loading.gif";

const Loading = () => {
    
    return (
        <div className={style.rootDiv}>
            <img className={style.loadingGif} src={gif} alt="Loading Gif"/>
            <p>LOADING...</p>
        </div>
    );
};

export default Loading;